import React, { useContext } from 'react'
import { Color } from '../../Common/Color'
import { Tabs } from 'antd'
import { t } from 'i18next'
import BoxStatistics from './BoxStatistics'
import AppointmentDurationStatistics from './AppointmentDurationStatistics'
import GlobalContext from '../GlobalContext'

export default function StatisticsPage () {
  const { boxes } = useContext(GlobalContext)

  return (
    <Tabs
      type='card'
      classNames={{ item: 'custom-tab-header' }}
      style={{ '--backgroundColor': Color.primary }}
      styles={{ root: { marginTop: '1em', backgroundColor: 'white' }, content: { padding: '0em 1em 1em 0em' } }}
      defaultActiveKey='appointmentDurationStatistics'
      items={[
        {
          label: t('Admin.Statistics.tab.appointmentDurationStatistics'),
          key: 'appointmentDurationStatistics',
          children: <AppointmentDurationStatistics />
        },
        {
          label: t('Admin.Statistics.tab.boxStatistics'),
          key: 'boxStatistics',
          children: <BoxStatistics boxes={boxes} />
        }
      ]}
    />
  )
}
